
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ProductPlanSettingType } from 'enums/ProductPlanSettingType';
import { Model, ModelProperty } from 'models/Model';


export class ProductPlanSettingModel extends Model<ProductPlanSettingModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'name', type: 'string' },
		{ name: 'data', type: 'string' },
		{ name: 'type', type: 'ProductPlanSettingType' }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public data: string;
	public type: ProductPlanSettingType;
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.data = '';
		this.type = 0;
		
	}
	getProperties(){
		return ProductPlanSettingModel.classProperties;
	}
}

